module.exports = __webpack_public_path__ + "pic/34.44bc0d13.png";